import {z} from 'zod'
import {BoolString} from './zod'

const envSchema = z.object({
  MODE: z.enum(['development', 'test', 'preview', 'staging', 'production']).catch('development'),
  VITE_BASE_URL: z.string(),
  VITE_IS_HUBSPOT_ENABLED: BoolString,
  VITE_LARA_APP_URL: z.string(),
  VITE_IS_GA_ENABLED: BoolString,
  VITE_GA_TRACKING_ID: z.string()
})

export const getEnvVars = (env: unknown = import.meta.env) => {
  return envSchema.parse(env)
}
